import React, { useContext, useEffect } from 'react';
import {
  Coins,
  Shield,
  Zap,
  Globe,
  ArrowRight,
  CheckCircle,
} from 'lucide-react';
import styles from './LandingPage.module.scss';
import { Image } from 'react-bootstrap';
import AuthContext from '../contexts/AuthContext';
import CashCorp from '../assets/mai.png';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';

function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData: user } = useContext(AuthContext);

  useEffect(() => {
    if (user) {
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [user, location, navigate]);
  return (
    <div className={styles.app}>
      {/* Navigation */}
      <nav className={styles.nav}>
        <div className={styles.navContainer}>
          <div className={styles.navLogo}>
            <Image src={CashCorp} alt="Mai Cash" width={20} height={20} />
            <span>Mai Cash</span>
          </div>
          <div className={styles.navLinks}>
            <button
              onClick={() => navigate('/login')}
              className={styles.navCta}
            >
              Get Started
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroContainer}>
          {/* <div className={styles.heroBadge}>
            <Zap />
            <span>Powered by Kalp Studio</span>
          </div> */}

          <h1 className={styles.heroTitle}>Mai Cash</h1>

          <p className={styles.heroSubtitle}>The Future of Digital Rewards</p>

          <p className={styles.heroDescription}>
            A revolutionary utility token that transforms how you interact with
            Organization's ecosystem. Earn, spend, and unlock exclusive content
            with seamless blockchain technology.
          </p>

          <div className={styles.heroButtons}>
            <button
              onClick={() => navigate('/login')}
              className={styles.heroPrimaryBtn}
            >
              Get Started
              <ArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* What is MaiCash */}
      <section
        id="about"
        className={`${styles.section} ${styles.sectionGlass}`}
      >
        <div className={styles.sectionContainer}>
          <div className={styles.aboutGrid}>
            <div>
              <h2 className={styles.sectionTitle}>What is Mai Cash?</h2>
              <p className={styles.sectionSubtitle}>
                Mai Cash is a utility token designed to power the next
                generation of digital media experiences within the Organization
                ecosystem. Built on cutting-edge blockchain technology for
                secure, transparent, and efficient transactions.
              </p>
            </div>

            <div className={styles.aboutCard}>
              <div className={styles.aboutCardIcon}>
                <Coins />
              </div>
              <h3 className={styles.aboutCardTitle}>Digital Utility Token</h3>
              <p className={styles.aboutCardText}>
                Your gateway to enhanced media experiences, exclusive content,
                and community rewards.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section id="features" className={styles.section}>
        <div className={styles.sectionContainer}>
          <div className={styles.featuresHeader}>
            <h2 className={styles.sectionTitle}>Key Features</h2>
            <p>
              Experience the power of blockchain technology with features
              designed for the modern digital media landscape.
            </p>
          </div>

          <div className={styles.featuresGrid}>
            <div className={styles.featuresCard}>
              <div className={`${styles.featuresCardIcon} ${styles.purple}`}>
                <Shield />
              </div>
              <h3 className={styles.featuresCardTitle}>Secure & Transparent</h3>
              <p className={styles.featuresCardText}>
                Built on blockchain technology ensuring complete security and
                transparency in all transactions.
              </p>
            </div>

            <div className={styles.featuresCard}>
              <div className={`${styles.featuresCardIcon} ${styles.indigo}`}>
                <CheckCircle />
              </div>
              <h3 className={styles.featuresCardTitle}>Exclusive Access</h3>
              <p className={styles.featuresCardText}>
                Unlock premium content, shows, and behind-the-scenes material
                available only to token holders.
              </p>
            </div>

            <div className={styles.featuresCard}>
              <div className={`${styles.featuresCardIcon} ${styles.pink}`}>
                <Globe />
              </div>
              <h3 className={styles.featuresCardTitle}>Global Ecosystem</h3>
              <p className={styles.featuresCardText}>
                Part of Organization's expanding digital ecosystem with
                continuous new features and partnerships.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={`${styles.section} ${styles.sectionGlass}`}>
        <div className={styles.sectionContainer}>
          <div className={styles.cta}>
            <h2 className={styles.ctaTitle}>Ready to Get Started?</h2>
            <p className={styles.ctaText}>
              Join the future of digital media with Mai Cash and unlock
              exclusive experiences.
            </p>
            <button
              onClick={() => navigate('/login')}
              className={styles.ctaButton}
            >
              Launch Mai Cash App
              <ArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContainer}>
          <div className={styles.footerTop}>
            <div className={styles.footerLogo}>
              <Coins />
              <span>Mai Cash</span>
            </div>

            <div className={styles.footerLinks}>
              <a
                href="/terms-and-conditions"
                target="_blank"
                className={styles.footerLink}
              >
                Terms
              </a>
              <a
                href="/privacy-policy"
                target="_blank"
                className={styles.footerLink}
              >
                Privacy
              </a>
              <a
                href="mailto:care@kalp.studio"
                target="_blank"
                className={styles.footerLink}
              >
                Support
              </a>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <p>
              © 2025 Mai Cash. All rights reserved.
              {/* Powered by Kalp Studio. */}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
